import L from "leaflet";
import pinPickupUrl from "../../static/ride-order/pin-pickup.svg";
import pinDropoffUrl from "../../static/ride-order/pin-dropoff.svg";

/** cargo-website limo booking map pins (Figma) — 56×56 */
const PICKUP_PIN_SIZE: [number, number] = [56, 56];
const PICKUP_PIN_ANCHOR: [number, number] = [28, 56];

const DROPOFF_PIN_SIZE: [number, number] = [56, 56];
const DROPOFF_PIN_ANCHOR: [number, number] = [25, 56];

export const pickupMarkerIcon = L.icon({
  iconUrl: pinPickupUrl,
  iconSize: PICKUP_PIN_SIZE,
  iconAnchor: PICKUP_PIN_ANCHOR,
});

export const dropoffMarkerIcon = L.icon({
  iconUrl: pinDropoffUrl,
  iconSize: DROPOFF_PIN_SIZE,
  iconAnchor: DROPOFF_PIN_ANCHOR,
});
